import { MolsonBox } from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'
import type { ReactNode } from 'react'

export const RuleSection = ({ children }: { children: ReactNode }) => {
  const theme = molsonUseTheme()

  return (
    <MolsonBox p={theme.spacing(5, 7.5)}>
      <MolsonBox
        sx={{
          background: theme.palette.secondary[100],
          borderRadius: 2
        }}
        p={theme.spacing(5, 4)}
      >
        {children}
      </MolsonBox>
    </MolsonBox>
  )
}
